import React, { useState } from 'react'
import './Contact.css'
import { API_URL } from './config'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  })
  const [status, setStatus] = useState('')

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    fetch(`${API_URL}/apps/kscanner/contact.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      include: 'credentials',
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setStatus('Message sent successfully!')
          setFormData({ name: '', email: '', message: '' }) // reset form
        } else {
          setStatus('Something went wrong. Please try again.')
        }
      })
      .catch(() => setStatus('Error sending message.'))
  }

  return (
    <div className="contact-page container py-5">
      <div className="contact-header text-center mb-4">
        <h2 className="contact-title">Get in Touch</h2>
        <p className="contact-subtitle">
          Have questions or need support? We’d love to hear from you. Fill out the form below or
          reach us directly.
        </p>
      </div>

      {/* Contact Form */}
      <div className="row justify-content-center">
        <div className="col-lg-6 col-12">
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group mb-3">
              <label htmlFor="name">Your Name</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-control"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                className="form-control"
                rows="5"
                placeholder="Write your message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="contact-btn">
              Send Message
            </button>
          </form>
          {status && <p className="form-status mt-3">{status}</p>}
        </div>
      </div>

      {/* Contact Info */}
      <div className="contact-info text-center mt-5">
        <h4>Other Ways to Reach Us</h4>
        <p>
          Email: <a href="mailto:support@karamale.com">support@karamale.com</a>
        </p>
        <p>Phone: +27 (0)78 236 5403</p>
        <p>WhatsApp: +27 (0)78 236 5403</p>
        <p>Address: Sunninghill, Sandton, Johannesburg, South Africa</p>
      </div>
    </div>
  )
}

export default Contact
